type Service = {
  code: string;
  select_teeth: boolean;
  select_quadrant: boolean;
  select_arch: boolean;
  select_surface: boolean;
  is_ortho: boolean;
  price: number | null;
  created_at: string;
  description: string;
  friendly_description: string;
  arch_min: number;
  arch_max: number;
  quadrant_min: number;
  quadrant_max: number;
  tooth_range_min: number;
  tooth_range_max: number;
  tooth_min: number;
  tooth_max: number;
  surface_min: number;
  surface_max: number;
  is_range_per_quadrant: boolean;
  allow_primary: boolean;
  allow_permanent: boolean;
  status: number;
  status_message: string;
  category: string;
  treatment_plan: boolean;
};

type Services = Service[];

export interface ApiError extends Error {
  status?: number;
  message: string;
}

export function isApiError(error: unknown): error is ApiError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as Record<string, unknown>).message === 'string'
  );
}

export interface MemberFormState {
  firstName: string;
  middleName: string;
  lastName: string;
  dob: string | null;
  identificationId: string;
  identificationType: string;
  gender: string;
  selfDescribe: string;
  email: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
}

export type { Service, Services };
